import React from 'react';
import styled from 'styled-components';
import { getImage } from 'gatsby-plugin-image';
import CoreImage from 'gatsby-theme-core/src/components/image';
import Section from '../components/section';

const Wrapper = styled.div`
  max-width: ${({ $maxWidthInPx }) => $maxWidthInPx || 800}px;
  margin: 0 auto;
`;

const Image = ({
  className,
  rowOptions,
  image,
  alt,
  maxWidthInPx,
}) => (getImage(image?.localFile) ? (
  <Section
    className={className}
    id={rowOptions?.sectionId || ''}
    backgroundColor={rowOptions?.backgroundColor}
    hideBottomSpacing={rowOptions?.hideBottomSpacing}
    hideTopSpacing={rowOptions?.hideTopSpacing}
    hideRow={rowOptions?.hideRow}
  >
    <Wrapper $maxWidthInPx={maxWidthInPx}>
      <CoreImage
        image={image}
        alt={alt}
      />
    </Wrapper>
  </Section>
) : null);

export default styled(Image)``;
